module.exports = __webpack_public_path__ + "img/noi-program-2.8403a864.jpg";